<template>
  <div>
    <Header :headerContent="headerContent" />
    <cross-page-info :crossPageContent="crossPageContent" />
    <frequently-asked-questions
      :faqTitle="faqTitle"
      :faqTitleDesc="faqTitleDesc"
      :fromBackend="true"
    />
    <Blog />
    <customer-comments />
  </div>
</template>

<script>
import Header from '@/component/cross-pages/Header'
import crossPageInfo from '@/component/cross-pages/CrossPageInfo'
import frequentlyAskedQuestions from '@/component/expansional-question-panel/AppQuestionPanel'
import Blog from '@/component/alo-kasko-blog-carousel/AppAloKaskoBlog'
import customerComments from '@/component/customer-comments/AppCustomerComments'
import PersonalAccidentData from '@/data/company-page-data/quick-sigorta/cross-pages/PersonalAccidentInsurance'
export default {
  metaInfo: {
    title: 'Quick Sigorta Ferdi Kaza Poliçesi İçin Teklif Alın',
    meta: [
      {
        name: 'description',
        content: 'Küçük kazalara karşı güvence altında olmak için Quick Sigorta Ferdi Kaza Sigortası yaptırın, gündelik kazaları güvence altına alın.'
      }
    ]
  },
  name: 'QuickSigortaPersonalInsurance',
  components: {
    Header,
    crossPageInfo,
    frequentlyAskedQuestions,
    Blog,
    customerComments
  },
  data () {
    return {
      headerContent: PersonalAccidentData.headerContent,
      crossPageContent: PersonalAccidentData.crossPageContent,
      faqTitle: PersonalAccidentData.faqTitle,
      faqTitleDesc: PersonalAccidentData.faqTitleDesc,
      getPrice: PersonalAccidentData.getPrice
    }
  }
}
</script>
